import React, { useState, useEffect } from 'react';
import { getSettings } from '../../services/api';
import { ExternalLink, Heart } from 'lucide-react';
import '../../styles/footer.css';

const Footer = () => {
  const [photographerInfo, setPhotographerInfo] = useState(null);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const settings = await getSettings();
        setPhotographerInfo({
          name: settings.photographer_name,
          tagline: settings.tagline,
          social: {
            instagram: settings.social_instagram,
            behance: settings.social_behance,
            pinterest: settings.social_pinterest
          }
        });
      } catch (error) {
        console.error('Error loading footer data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">{photographerInfo?.name || 'Portfolio'}</h3>
            <p className="footer-tagline">{photographerInfo?.tagline || 'Photographer'}</p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>Quick Links</h4>
              <a href="#gallery" data-gas>Gallery</a>
              <a href="#about" data-gas>About</a>
              <a href="#contact" data-gas>Contact</a>
            </div>

            <div className="footer-column">
              <h4>Categories</h4>
              <a href="#gallery" data-gas>Events</a>
              <a href="#gallery" data-gas>Portraits</a>
              <a href="#gallery" data-gas>Landscapes</a>
              <a href="#gallery" data-gas>Commercial</a>
              <a href="#gallery" data-gas>Fine Art</a>
            </div>

            <div className="footer-column">
              <h4>Connect</h4>
              <a href={photographerInfo?.social?.instagram} target="_blank" rel="noopener noreferrer">
                Instagram <ExternalLink size={14} />
              </a>
              <a href={photographerInfo?.social?.behance} target="_blank" rel="noopener noreferrer">
                Behance <ExternalLink size={14} />
              </a>
              <a href={photographerInfo?.social?.pinterest} target="_blank" rel="noopener noreferrer">
                Pinterest <ExternalLink size={14} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} {photographerInfo?.name || 'Portfolio'}. All rights reserved.
          </p>
          <p className="footer-credit">
            Made with <Heart size={16} className="heart-icon" /> for capturing moments
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;